import theUseStateHook from "./Articles/the-usestate-hook";
import problemSolving from "./Articles/problem-solving";

const articleData = [
  theUseStateHook, problemSolving
];

export default articleData;
